/**
 * Created by BFR on 07/09/2015.
 */
define('adminSettingDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminSettingDetailsTpl',
  'adminSettingTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  settingTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var SettingDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.setting-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      code: '.p-code',
      sGroup: '.p-sGroup'
    },

    events: {
      'click @ui.tab': 'onTabClick',
      'change @ui.collectionToggle': 'onCollectionToggle'
    },

    regions: {
      settingDetailTab: '#detail-tab'
    },

    behaviors: function() {
        var redirectUrl;
        if (this.options.data.fromKitp) {
            redirectUrl = 'admin/kitp/' + this.options.model.get('refKitP').secId + '/setting';
        } else {
            redirectUrl = 'admin/settings';
        }
        return {
            BackToList: {
                behaviorClass: BackToListBehavior,
                redirectUrl: redirectUrl
            }
        };
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.settingTabs = settingTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.setting-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    },

    onTabClick: function(e) {
      var $target = $(e.currentTarget),
        tab = {
          route: $target.data('route'),
          role: $target.data('role'),
          name: $target.data('name')
        };

      this.ui.tab.removeClass('active');
      this.ui.tabPane.removeClass('active');
      $target.addClass('active');
      this.$('.tab-pane[data-name="' + tab.name + '"]').addClass('active');

      this.triggerMethod('click:tab', tab);
    },

    onHeaderChange: function(setting) {
      this.ui.code.text(setting.code);
      this.ui.sGroup.text(setting.sGroup);
    }
  });

  module.exports = SettingDetailsView;
});
